import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Accordion, Card, Col, Row } from 'react-bootstrap';
import PlaceIcon from '../../icons/locationPin.svg';
import ContentCard from '../../common/ContentCard';
import MapLogo from '../../icons/map-empty.svg';
import EditLogo from '../../icons/pencil.svg';
import DeleteLogo from '../../icons/trash-filled.svg';
import MapPin from '../../icons/mapPin.svg';
import './styles.scss';
import CheckBox from '../../common/CheckBox';
import { noop } from '../../common/propTypes';
import EditPlaceModal from './EditPlaceModal';
import DeletePlaceModal from './DeletePlaceModal';

function PlaceCard({
    status,
    address,
    researchProjectId,
    isAssigned,
    title,
    researchCard,
    id,
    updatedBy,
    mapContent,
    onPlaceClick,
    userId,
    // loggedInUser,
    selectable,
    selectedUsers,
    activePlaceId,
    onSelectUser,
    selectAll,
    name,
    location,
    locationUrl,
    locationId,
}) {
    //const segmentCreatedByUser = loggedInUser && loggedInUser.id == userId;
    const ResearchersCardComponent = researchCard;
    const { MapComponent } = mapContent;
    const [open, setOpen] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);

    let { center, dataPoints, zoom } = mapContent;

    return (
        <div className="placeAccordainCards">
            <ContentCard
                showDropDown={false}
                content={
                    <Card className="d-flex accordion-card">
                        <Accordion.Collapse
                            eventKey={id}
                            className="segmentCardBody"
                        >
                            <Card.Body>
                                <Row>
                                    <Col md={6}>
                                        {
                                            <ContentCard
                                                heading={'Map'}
                                                content={
                                                    <>
                                                        <MapComponent
                                                            id="places-map"
                                                            center={center}
                                                            markerClickable={
                                                                false
                                                            }
                                                            dataPoints={dataPoints.map(
                                                                (s, index) => ({
                                                                    id: index,
                                                                    icon: MapPin,
                                                                    position: {
                                                                        lat:
                                                                            s.lat,
                                                                        lng:
                                                                            s.lng,
                                                                    },
                                                                    tags: [
                                                                        title,
                                                                    ],
                                                                }),
                                                            )}
                                                            zoom={zoom}
                                                            options={{
                                                                scrollwheel: false,
                                                                disableDefaultUI: true,
                                                                zoomControl: true,
                                                            }}
                                                        />
                                                    </>
                                                }
                                                className="h-100 segment-collapse-container"
                                            />
                                        }
                                    </Col>
                                    <Col md={6}>
                                        {activePlaceId == id && (
                                            <ResearchersCardComponent
                                                placeId={id}
                                                userId={userId}
                                                researchProjectId={
                                                    researchProjectId
                                                }
                                                locationId={locationId}
                                            />
                                        )}
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Accordion.Collapse>
                        <Accordion.Toggle
                            as={Card.Header}
                            eventKey={id}
                            className="placeCardHeader"
                        >
                            <div className="row m-0">
                                <div className="col userInfo d-flex align-items-center">
                                    {selectable && (
                                        <CheckBox
                                            id={`place-checkbox${id}`}
                                            disabled={isAssigned}
                                            selected={
                                                !isAssigned &&
                                                (selectAll
                                                    ? true
                                                    : selectedUsers[id]
                                                    ? true
                                                    : false)
                                            }
                                            isBold={true}
                                            onClick={() => onSelectUser(id)}
                                        />
                                    )}
                                    <div
                                        className={`place-avatar avatar Medium`}
                                    >
                                        <img
                                            src={PlaceIcon}
                                            alt=""
                                            className="rounded-image"
                                        />
                                    </div>
                                    <div className="userName">
                                        <h4 className="title segmentName">
                                            {title}
                                            {isAssigned ? (
                                                <label className="title-badge badge-primary">
                                                    Assigned
                                                </label>
                                            ) : (
                                                <label className="title-badge badge-secondary">
                                                    Unassigned
                                                </label>
                                            )}
                                        </h4>
                                        <h4 className="title">{address}</h4>
                                        <small className="text-uppercase dateStamp">
                                            {`UPDATED BY ${updatedBy}`}
                                        </small>
                                    </div>
                                </div>
                                <div className="col d-flex justify-content-center">
                                    <div className="stats">
                                        <small className="title text-uppercase">
                                            Status
                                        </small>
                                        <div className="stat h2 text-primary">
                                            {status}
                                        </div>
                                    </div>
                                </div>
                                <div className="col align-self-center text-right">
                                    <a
                                        href={locationUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img
                                            src={MapLogo}
                                            className="actionLogo"
                                        />
                                    </a>
                                    <img
                                        onClick={(e) => {
                                            setOpen(true);
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }}
                                        src={EditLogo}
                                        className="actionLogo"
                                    />
                                    {
                                        <img
                                            onClick={(e) => {
                                                setConfirmDelete(true);
                                                e.preventDefault();
                                                e.stopPropagation();
                                            }}
                                            src={DeleteLogo}
                                            className="actionLogo"
                                        />
                                    }
                                    <svg
                                        className="ico-arrowCollapse"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        onClick={() => onPlaceClick(id)}
                                    >
                                        <path
                                            fill="#000"
                                            fillRule="nonzero"
                                            d="M8.876 8.047l-3.3-3.3a.667.667 0 0 1 .943-.942l3.771 3.771c.26.26.26.682 0 .943L6.519 12.29a.667.667 0 0 1-.943-.943l3.3-3.3z"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </Accordion.Toggle>
                    </Card>
                }
            />
            <EditPlaceModal
                open={open}
                handleClose={() => setOpen(false)}
                place={{ id, name, location }}
            />

            <DeletePlaceModal
                show={confirmDelete}
                placeId={id}
                onClose={() => {
                    setConfirmDelete(false);
                }}
            />
        </div>
    );
}

PlaceCard.propTypes = {
    id: PropTypes.number,
    avatar: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    updatedBy: PropTypes.string,
    mapContent: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
    activePlaceId: PropTypes.number,
    title: PropTypes.string,
    selectable: PropTypes.bool,
    onSelectUser: PropTypes.func,
    selectedUsers: PropTypes.object,
    researchCard: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
    onPlaceClick: PropTypes.func,
    loggedInUser: PropTypes.object,
    onEditClick: PropTypes.func,
    userId: PropTypes.number,
    status: PropTypes.string,
    address: PropTypes.string,
    researchProjectName: PropTypes.string,
    researchProjectId: PropTypes.number,
    isAssigned: PropTypes.bool,
    selectAll: PropTypes.bool,
    name: PropTypes.string,
    location: PropTypes.object,
    locationUrl: PropTypes.string,
    locationId: PropTypes.number,
};

PlaceCard.defaultProps = {
    id: null,
    updatedBy: '',
    title: '',
    date: '',
    litterCount: '0',
    duration: '0 sec',
    distance: '0 m',
    mapContent: null,
    researchCard: null,
    onPlaceClick: noop,
    activePlaceId: null,
    selectable: false,
    selectedUsers: {},
    onSelectUser: noop,
    onEditClick: noop,
    selectAll: false,
    name: '',
    location: {},
    locationUrl: '',
};

export default PlaceCard;
